import React, { FC } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FormItem, useFiltersLabel, FiltersNameEnum, FilterDrawerType } from '@blocs.filter';
import { DateRange } from '../../../FilterCollection';
import { FiltersCategoryNameEnum } from '../../shared/types';

interface Props {
  type: FilterDrawerType;
}

const PregnancyDueDateCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { isCategoryMatchedSearch } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.pregnancyDueDate);

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <DateRange
          dateRangeName={FiltersNameEnum.pregnancyDueDateRange}
          dateRangeMinName={FiltersNameEnum.min}
          dateRangeMaxName={FiltersNameEnum.max}
          label={filtersLabelOfAudience[FiltersNameEnum.pregnancyDueDateRange]}
        />
      </FormItem>
    )
  );
};

export default PregnancyDueDateCategory;
